import React from 'react';
import Meta from '../components/Meta';
import { ListGridBannerMinor } from '../components/Banners';
import { ListGridItem } from '../components/PageHelpers';

// eslint-disable-next-line react/prop-types
const HistoricNeighborhoodGrid = ({ data }) => {
  const page = data.mortyPage;

  // Filter out Featured Events page
  const allPages = data.allOutdoors.edges.filter(p => p.node.title !== 'Featured Events');

  // If there are events, add them to the data
  const gridData = allPages.concat(data.allOutdoors.edges);

  // Force ordering
  const pageRoutes = [
    '/live-downtown/historic-neighborhoods/jackson-ward/',
    '/live-downtown/historic-neighborhoods/arts-district/',
    '/live-downtown/historic-neighborhoods/shockoe-bottom/',
    '/live-downtown/historic-neighborhoods/shockoe-slip/',
    '/live-downtown/historic-neighborhoods/monroe-ward/',
    '/live-downtown/historic-neighborhoods/court-end/',
    '/live-downtown/historic-neighborhoods/financial-district/',
    '/live-downtown/historic-neighborhoods/manchester/',
    '/live-downtown/historic-neighborhoods/riverfront-district/',
    '/live-downtown/historic-neighborhoods/city-center/' ,
  ];

  const orderedPages = [];
  pageRoutes.forEach((route) => {
    const item = gridData.find(obj => obj.node.route === route);
    if (item) {
      orderedPages.push(item);
    }
  });

  // Filter out undefined values
  const filteredPages = orderedPages.filter(Boolean);

  return (
    <div>
      <Meta page={page} />
      <ListGridBannerMinor page={page} titleWidth="696" />
      <div className="pv3 pv4-m pv5-l flex items-center justify-center">
        <div className="w-100">
          {filteredPages && filteredPages.map(d => (
            <ListGridItem key={d.node.id} page={d.node} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HistoricNeighborhoodGrid;

export const pageQuery = graphql`
query HistoricNeighborhoodGrid($id: String!) {
  mortyPage(id: { eq: $id }) {
    title
    route
    subtitle
    route
    metaTitle
    metaDescription
    metaKeywords
    abstract
    abstractPhotoAltText
    abstractPhotoFocalPointX
    abstractPhotoFocalPointY
    abstractPhoto {
      url
    }
  }
  allOutdoors: allMortyPage(filter: {
    route: { ne: "/dummy-page" }
    section: { eq: "Historic Neighborhoods" }
}) {
    edges {
      node {
        id
        title
        route
        section
        abstract
        template
        abstractPhotoAltText
        abstractPhotoFocalPointX
        metaDescription
        abstractPhotoFocalPointY
        abstractPhoto {
          url
        }
      }
    }
  }
}
`;
export const previewQuery = `
query OutdoorGrid($id: String!) {
  mortyPage(id: { eq: $id }) {
    title
    route
    subtitle
    route
    metaTitle
    metaDescription
    metaKeywords
  }
  allOutdoors: allMortyPage(filter: {
    route: { ne: "/dummy-page" }
    section: { eq: "Historic Neighborhoods" }
}) {
    edges {
      node {
        id
        title
        route
        section
        abstract
        template
        abstractPhotoAltText
        abstractPhotoFocalPointX
        metaDescription
        abstractPhotoFocalPointY
        abstractPhoto {
          url
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/templates/Historic-Neighborhood-Grid.js